/**
 * Sentry instrumentation — MUST be imported before any other code in main.jsx
 * so that Sentry can capture errors from module-init time onward.
 */
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ||
  'https://a69c20b57f7e73328e0da9d5a749d918@o4511437552680960.ingest.us.sentry.io/4511437712261120'

Sentry.init({
  dsn: SENTRY_DSN,
  sendDefaultPii: true,

  // Environment + release tagging
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION || undefined,

  integrations: [
    // React Router v6 browser tracing — tracks route changes as transactions
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    // Session Replay
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Performance Monitoring
  tracesSampleRate: import.meta.env.PROD ? 0.3 : 1.0,

  // Trace propagation — restrict to your domain(s)
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/.*\.narasimhaperumal\.org/,
    /^https:\/\/.*\.vercel\.app/,
  ],

  // Session Replay sampling
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  enabled: import.meta.env.PROD,
})

export { Sentry }
